import { createFileRoute } from '@tanstack/react-router';

import { RrhhCompaniesPage } from '@/features/rrhh/components/rrhh-companies-page';

export const Route = createFileRoute('/_app/rrhh/')({
  component: RrhhCompaniesPage,
});
